import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { HistoryData } from "./history";
import { Utilities } from "./utilities";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";
import { IReserve } from "../shared/models/reserve.model";

@Injectable()
export class ReserveService {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private historyData: HistoryData,
    private utilities: Utilities,
    private tracking: TrackingProvider,
  ) { }

  public createOrUpdate(clientId: string, reserve: any, eventId: string) {
    if (reserve.id === "") {
      this.action = "create";
      reserve.id = this.afDb.createPushId();
      reserve.created_at = new Date().getTime();
    } else {
      this.action = "update";
      reserve.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/Reserves/${reserve.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Reserves/${reserve.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(reference)
        .update(reserve)
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.reserves, reserve.id, clientId, eventId, reserve, "Creacion/actualizacion reserve");
          resolve(reserve);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public get(clientId: string, eventId: string): Observable<IReserve[]> {
    let reference = `Clients/${clientId}/Interactivity/Reserves`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Reserves`;
    }
    return this.afDb.list<IReserve>(reference).valueChanges();
  }

  public getActive(clientId: string, eventId: string): Observable<IReserve[]> {
    let reference = `Clients/${clientId}/Interactivity/Reserves`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Reserves`;
    }
    return this.afDb.list<IReserve>(
      reference,
      (ref) => ref.orderByChild("state").equalTo(true),
    ).valueChanges();
  }

  public getById(clientId: string, id: string, eventId: string): Observable<IReserve> {
    let reference = `Clients/${clientId}/Interactivity/Reserves/${id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Reserves/${id}`;
    }
    return this.afDb
      .object<IReserve>(reference)
      .valueChanges();
  }

  public createOrUpdateExtra(clientId: string, reserveExtra: any, eventId: string) {
    if (reserveExtra.id === "") {
      this.action = "create";
      reserveExtra.id = this.afDb.createPushId();
      reserveExtra.created_at = new Date().getTime();
    } else {
      this.action = "update";
      reserveExtra.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/ReserveExtra/${reserveExtra.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/ReserveExtra/${reserveExtra.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(reference)
        .update(reserveExtra)
        .then(() => {
          resolve(reserveExtra);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getExtraById(clientId: string, id: string, eventId: string): Observable<any> {
    let reference = `Clients/${clientId}/Interactivity/ReserveExtra/${id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/ReserveExtra/${id}`;
    }
    return this.afDb
      .object<any>(reference)
      .valueChanges();
  }

  public getExtra(clientId: string, eventId: string): Observable<any[]> {
    let reference = `Clients/${clientId}/Interactivity/ReserveExtra`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/ReserveExtra`;
    }
    return this.afDb.list<any>(reference).valueChanges();
  }
}



// WEBPACK FOOTER //
// ./src/providers/reserve.service.ts